import { useLocale, useTranslations } from 'next-intl';
import { LocaleSwitcherSelect } from './locale-switcher-select';

type Props = {
    className?: string;
    isDirectionUp?: boolean;
};

export const LocaleSwitcher = ({ className = '', isDirectionUp }: Props) => {
    const t = useTranslations('LocaleSwitcher');
    const locale = useLocale();

    return (
        <LocaleSwitcherSelect
            defaultValue={locale}
            label={t('label')}
            className={className}
            isDirectionUp={isDirectionUp}
        />
    );
};
